/**
 * The body of an officials import 409: the import's own report, from the first
 * upload or from Confirm & Import in the duplicate review.
 */
export interface OfficialsImportReport {
  success?: { count?: number }
  failed?: { count?: number; errors?: unknown[] }
  conflicts?: { count?: number; conflicts?: unknown[] }
  file?: { name: string; rows: string }
}

/** What the officials import dialog shows for a report. */
export interface OfficialsImportReportView {
  /** The failed rows, or the rows to review when `isReview` is true. */
  rows: unknown[]
  /** Open the duplicate review. */
  isReview: boolean
  /** The failed-rows download, when rows failed. */
  failedRowsFile: { name: string; rows: string } | null
  /** How many rows were imported anyway, when any were. */
  importedCount: number | null
}

/**
 * Failed rows win over rows to review, as in the roster import: they replace a
 * duplicate review still on screen from the first upload, which would
 * otherwise keep rendering and hide them.
 */
export const officialsImportReportView = (
  report: OfficialsImportReport
): OfficialsImportReportView => {
  const importedCount = report.success?.count ?? 0
  const imported = importedCount > 0 ? importedCount : null

  if ((report.failed?.count ?? 0) > 0) {
    return {
      rows: report.failed?.errors ?? [],
      isReview: false,
      failedRowsFile: report.file ?? null,
      importedCount: imported,
    }
  }

  if ((report.conflicts?.count ?? 0) > 0) {
    return {
      rows: report.conflicts?.conflicts ?? [],
      isReview: true,
      failedRowsFile: null,
      importedCount: imported,
    }
  }

  return {
    rows: [],
    isReview: false,
    failedRowsFile: null,
    importedCount: imported,
  }
}
